import React from 'react';
import { ButtonProps, ButtonBase } from '@src/shared/ui/buttons';
import Lottie from 'lottie-react';
import loadingJson from './loadingJson.json';
import { colors } from '@src/config/theme/tokens';

export const PrimaryButton: React.FC<ButtonProps> = ({
  id,
  children,
  onClick,
  className,
  disabled,
  loading,
}) => {
  let bg = colors.neutral30;

  if (disabled) {
    if (loading) {
      bg = colors.primary30;
    } else {
      bg = colors.neutral30;
    }
  }
  if (loading) {
    bg = colors.primary30;
  }

  return (
    <ButtonBase
      id={id}
      onClick={loading || disabled ? undefined : onClick}
      className={`${className} bg-[${bg}]`}
      variant='contained'
      disabled={loading ? false : disabled}
    >
      {loading ? (
        <Lottie className='h-8' animationData={loadingJson} loop={true} />
      ) : (
        children
      )}
    </ButtonBase>
  );
};
